<template>
  <!-- Old bit.dev component -->
  <div class="c-base-input-price">
    <div class="control" :class="{ 'has-error': hasError }">
      <input
        @click="onFocusEvent"
        @focus="onFocusEvent"
        @blur="onFocus = false"
        v-on:keyup.enter="$emit('entered')"
        v-money="money"
        v-model.lazy="price"
        ref="input"
        type="tel"
        class="c-base-input-price__input input has-text-centered"
      />
      <i class="bar"></i>
      <p
        v-if="hasError"
        class="help is-error has-text-centered"
        v-html="errorMessage"
      ></p>
    </div>
    <span
      :class="{ 'c-base-input-price--label-off': onFocus }"
      class="c-base-input-price__label"
    >
      <span
        :class="{
          'has-text-error': hasError && stringToNumber(this.price) === 0,
        }"
        class="c-base-input-price__prefix"
        >R$
      </span>
      <span
        :class="{
          'has-text-error': hasError,
          'has-text-support': !hasError && isTouched,
        }"
        class="c-base-input-price__price"
        >{{ price }}</span
      >
    </span>
  </div>
</template>

<script>
import { VMoney } from 'v-money'
import currency from 'currency.js'

export default {
  props: {
    initialPrice: {
      type: Number,
      default: 0,
    },
    // Define limit min to input
    min: {
      type: Number,
      default: 0,
    },
    // Define limit max to input
    max: {
      type: Number,
      default: 200,
    },
    // Define limit max withdraw of the day
    limit: {
      type: Number,
      require: true,
    },
  },

  data() {
    return {
      price: 0,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false,
      },
      onFocus: '',
      isTouched: '',
      hasError: '',
      errorMessage: '',
    }
  },

  watch: {
    // Watch and emit event when price changed with of value
    price(payload) {
      const value = this.stringToNumber(payload)
      this.$emit('price', {
        currency: payload,
        value,
      })
      if (!this.isTouched && value != 0) this.isTouched = true
      this.showErrors()
    },
  },

  mounted() {
    this.showErrors()
    this.price = this.numberToString(this.initialPrice)
  },

  methods: {
    onFocusEvent() {
      this.onFocus = true
      this.price = this.price
      const input = this.$refs.input
      if ('selectionStart' in input)
        input.selectionStart = input.selectionEnd = input.value.length
    },

    // convert string price to value type Number
    stringToNumber(value) {
      return currency(value, {
        separator: '.',
        decimal: ',',
      }).value
    },

    // convert number price to value type String
    numberToString(value) {
      return currency(value, {
        separator: '.',
        decimal: ',',
      }).format()
    },

    showErrors() {
      const value = this.stringToNumber(this.price)
      const minFormatted = this.numberToString(this.min)
      const maxFormatted = this.numberToString(this.max)
      if (this.isTouched)
        this.hasError =
          value < this.min || value > this.max || value > this.limit
      else this.hasError = false

      if (value < this.min) {
        this.errorMessage =
          'O valor mínimo permitido para essa transação é de R$' +
          minFormatted +
          '.'
      } else if (value > this.max) {
        this.errorMessage =
          'O valor informado excede o limite permitido para essa transação. Caso queira adicionar um valor acima de R$' +
          maxFormatted +
          ' entre em contato com o nosso atendimento...'
      } else this.errorMessage = ''
    },
  },

  directives: { money: VMoney },
}
</script>

<style lang="scss">
@import '@/assets/scss/bit-assets/vendors/bulma/material-form';

.c-base-input-price {
  position: relative;
  max-width: 225px;
  margin: 0 auto;

  &__input {
    font-size: em(24) !important;
    font-weight: bold;
    color: transparent;
    height: 38px !important;
    line-height: 1 !important;
    position: relative;
    z-index: 2;
  }

  &__label {
    @include position(absolute, 5px, 0, auto, 0);
    margin: 0 auto;
    z-index: 0;
    text-align: center;
    transition: 0.3s all ease;
  }

  &--label-off {
    position: fixed;
    z-index: 1;
    opacity: 0;
    visibility: hidden;
  }

  &__prefix {
    font-size: em(20);
    font-weight: bold;
    color: $gray-4;
  }

  &__price {
    font-size: em(26);
    font-weight: bold;
    color: $gray-4;
  }
}
</style>
